import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { MdSearchOff } from "react-icons/md";
import AuthContext from "../../store/auth-context";
import PageHeading from "../Util/PageHeading";
import styles from "./NotFound.module.css";

/**
 * Page not found (v1.3 ticket 22, owner ruling Q35). Any address the routes do not know (routes.js `path: "*"`), inside
 * the portal's paths or outside them. v1.2 showed React Router's own error screen there: no main region, no h1, nothing
 * to go on with, and the previous page's tab title. Util/PublicPageLayout puts this page in the portal shell — with the
 * investor navigation and skip link for a signed-in Investor, without them for anyone else — and titles the tab
 * "Page not found | RCMC RTA" (the route's `handle.title`).
 */
/** The way on: a signed-in Investor (or one awaiting approval, whose Portfolio shows the Account Pending dialog) to
 *  Portfolio; Operations back to the portal, which sends them to their own first page; anyone else to sign in. Null while
 *  a stored session's user details are on their way (review of 22: an Operations user saw "Go to your Portfolio" turn
 *  into "Return to the portal"); a session the server refuses ends, and the link to sign in follows */
function wayOn(authTokens, user) {
  if (!authTokens) return { to: "/login", label: "Sign in to the investor portal" };
  if (!user) return null;
  if (user.is_admin) return { to: "/login", label: "Return to the portal" };
  return { to: "/user/portfolio", label: "Go to your Portfolio" };
}

const NotFound = () => {
  const { authTokens, user } = useContext(AuthContext);
  const way = wayOn(authTokens, user);

  return (
    <div className={styles["page"]}>
      <PageHeading icon={<MdSearchOff style={{ marginRight: "5px" }} />}>Page not found</PageHeading>
      <div className={styles["content"]}>
        <p>This page does not exist in the portal.</p>
        {way && (
          <p>
            <Link to={way.to}>{way.label}</Link>
          </p>
        )}
      </div>
    </div>
  );
};

export default NotFound;
